/* eslint-disable */
import { useState, useEffect } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { useDispatch } from "react-redux";
import { updateAccount } from "../../redux/account/account";
import LoadingDots from "./loading-dots";
import { deleteDomain } from "../../api/removeDomaine";
import { Modal, Button } from "antd";
import { useTranslation } from "react-i18next";
export default function DomainCard({
  domain,
  revalidateDomains,
  domainStatus,
  isDelete,
  existingDomain,
  id,
  refreshPage,
  modification,
}) {
  // État pour la suppression
  const [removing, setRemoving] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const dispatch = useDispatch();

  // ÉTATS POUR L'ÉDITION (MODIFICATION)
  const [isEditing, setIsEditing] = useState(false);
  const [localDomain, setLocalDomain] = useState(domain);
  const [newStoreName, setNewStoreName] = useState("");

  useEffect(() => {
    setLocalDomain(domain);
    const main = getMainName(domain);
    setNewStoreName(main);
  }, [domain]);

  // Rechecks toutes les 5s (tant que non verified + configured)
  useEffect(() => {
    if (domainStatus?.verified && domainStatus?.configured) return;

    const intervalId = setInterval(async () => {
      setIsValidating(true);
      try {
        await revalidateDomains();
      } catch (err) {
        console.error(err);
      } finally {
        setIsValidating(false);
      }
    }, 5000);

    return () => clearInterval(intervalId);
  }, [revalidateDomains, domainStatus?.verified, domainStatus?.configured]);

  // SUPPRESSION du domaine (Vercel + Firestore)
  const handleDelete = async () => {
    setRemoving(true);
    try {
      const res = await fetch(
        "https://backend.foorweb.store/api/deleteDomain",
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ domain }),
        }
      );

      const result = await res.json();

      if (!res.ok) {
        throw new Error(
          result?.error || "Erreur inconnue lors de la suppression"
        );
      }
      // تحديث بيانات الحساب في Firestore
      await updateDoc(doc(db, "account", id), {
        store: `https://${existingDomain}/`,
        confirmDomain: false,
      });

      // Mettre à jour le state `account` dans Redux
      try {
        dispatch(
          updateAccount({ store: `https://${existingDomain}/`, confirmDomain: false })
        );
      } catch (e) {
        console.error("Redux dispatch failed:", e);
      }

      refreshPage();
    } catch (error) {
      console.error(error);
      alert(t("ui.domainDeleteError"));
    } finally {
      setRemoving(false);
    }
  };

  // Ouvrir/Fermer la modale de confirmation de suppression
  const showDeleteConfirmModal = () => setIsDeleteModalOpen(true);
  const handleCancel = () => setIsDeleteModalOpen(false);
  const handleConfirmDelete = async () => {
    setIsDeleteModalOpen(false);
    await handleDelete();
  };

  // ENREGISTRER la modification du sous-domaine
  const handleSaveEdit = async () => {
    try {
      const response = await fetch(
        `https://us-central1-e-commerce-17eb9.cloudfunctions.net/checkstorename?storeName=${newStoreName}`
      );
      if (!response.ok) {
        alert(t("domainSettings.domain-card.edit.exists"));
        return;
      }

      const data = await response.json();
      if (!data.unique) {
        alert(data.message || t("domainSettings.domain-card.edit.notUnique"));
        return;
      }

      const finalUrl = `https://${newStoreName}.foorweb.store/`;

      await updateDoc(doc(db, "account", id), {
        storeName: finalUrl,
        store: finalUrl,
      });

      // Mettre à jour le state `account` dans Redux
      try {
        dispatch(updateAccount({ storeName: finalUrl, store: finalUrl }));
      } catch (e) {
        console.error("Redux dispatch failed:", e);
      }

      setLocalDomain(finalUrl);

      refreshPage();

      setIsEditing(false);
    } catch (error) {
      console.error(error);
      alert(t("ui.storeNameUpdateError"));
    }
  };

  function getMainName(url = "") {
    return (
      url
        .replace(/^https?:\/\//, "") // Supprime "http://" ou "https://"
        .replace(/^www\./, "") // Supprime "www." s'il est présent
        .split("/")[0] // Prend la partie avant le premier "/"
        .split(".")[0] || ""
    ); // Retourne la première partie avant le "."
  }

  return (
    <>
      {/* MODALE: Confirmation de suppression */}
      <Modal
        className="text-right"
        title={
          <h4 className="text-[#9e68ba] font-bold mb-0 text-right">
            {t("domain-card.modal.title")}
          </h4>
        }
        open={isDeleteModalOpen}
        onCancel={handleCancel}
        footer={[
          <Button
            key="cancel"
            onClick={handleCancel}
            className="border border-gray-300 hover:border-gray-400"
          >
            {t("domain-card.modal.cancel")}
          </Button>,
          <Button
            key="confirm"
            type="primary"
            danger
            onClick={handleConfirmDelete}
            disabled={removing}
            className="bg-red-500 hover:bg-red-600"
          >
            {removing ? <LoadingDots /> : t("domain-card.modal.confirm")}
          </Button>,
        ]}
      >
        <p className="text-right text-gray-700">
          {t("domain-card.modal.message")}{" "}
          <strong className="text-[#9e68ba]">{localDomain}</strong> ؟
        </p>
      </Modal>

      {/* CARD PRINCIPAL */}
      <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 mb-4 border border-[#fbf4ff] dark:!border-[#3c3a3d] hover:border-purple-200 dark:hover:!border-[#9e68ba] transition">
        <div className="flex items-center justify-between">
          {/* URL ET INPUT */}
          <div className="flex items-center">
            <button
              className="text-[#9e68ba] hover:text-[#9e68ba] mr-3"
              onClick={() => window.open(`${localDomain}`, "_blank")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="dark:!stroke-[#9e68ba]"
              >
                <path d="M15 3h6v6" />
                <path d="M10 14 21 3" />
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
              </svg>
            </button>

            <div className="flex-1">
              {isEditing ? (
                <input
                  type="text"
                  value={newStoreName}
                  onChange={(e) => setNewStoreName(e.target.value)}
                  className="border border-purple-300 focus:border-purple-500 focus:ring-1 focus:ring-purple-200 rounded-md px-3 py-2 text-gray-700 dark:!text-gray-200 dark:!bg-[#141414] dark:!border-[#3c3a3d] w-full outline-none"
                />
              ) : (
                <div className="font-medium mx-4 text-gray-800 dark:!text-gray-200">
                  {localDomain}
                </div>
              )}
            </div>
          </div>

          {/* ACTIONS */}
          <div className="flex items-center space-x-3">
            {/* STATUS INDICATORS */}
            {domainStatus?.configured && (
              <span className="px-2 py-1 bg-green-50 dark:!bg-green-900 text-green-700 dark:!text-green-300 text-xs rounded-full flex items-center">
                <span className="w-2 h-2 bg-green-500 rounded-full mr-1"></span>
                {domainStatus?.verified
                  ? t("domain-card.status.verified")
                  : t("domainSettings.domain-card.status.configured")}
              </span>
            )}

            {/* VERIFY BUTTON */}
            {isDelete && (
              <button
                onClick={async () => {
                  setIsValidating(true);
                  try {
                    await revalidateDomains();
                  } catch (e) {
                    console.error(e);
                  } finally {
                    setIsValidating(false);
                  }
                }}
                disabled={isValidating}
                className={`text-sm px-3 py-1.5 rounded-md border ${
                  isValidating
                    ? "border-gray-200 bg-gray-100 text-gray-400 dark:!bg-[#141414] dark:!border-[#3c3a3d] dark:!text-gray-500 cursor-not-allowed"
                    : "border-purple-300 bg-[#fcf6ff] dark:!bg-[#2a2a2a] text-[#9e68ba] hover:bg-[#faf1ff] dark:hover:!bg-[#3a3a3a]"
                }`}
              >
                {isValidating ? (
                  <LoadingDots />
                ) : (
                  t("domain-card.status.verified")
                )}
              </button>
            )}

            {/* DELETE BUTTON */}
            {isDelete && (
              <button
                onClick={() => {
                  if (domainStatus?.configured && domainStatus?.verified) {
                    showDeleteConfirmModal();
                  } else {
                    handleDelete();
                  }
                }}
                disabled={removing}
                className={`text-sm px-3 py-1.5 rounded-md ${
                  removing
                    ? "bg-gray-100 text-gray-400 border-gray-200 dark:!bg-[#141414] dark:!text-gray-500 dark:!border-[#3c3a3d] cursor-not-allowed"
                    : "bg-red-50 text-red-600 dark:!bg-[#3a1f1f] dark:!text-red-400 border border-red-300 hover:bg-red-100 dark:hover:!bg-[#4a2a2a]"
                }`}
              >
                {removing ? <LoadingDots /> : t("domain-card.actions.delete")}
              </button>
            )}

            {/* EDIT/SAVE BUTTON */}
            {modification && (
              <button
                onClick={isEditing ? handleSaveEdit : () => setIsEditing(true)}
                className="text-[#9e68ba] hover:text-[#9e68ba] dark:!text-[#9e68ba]"
              >
                {isEditing ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="dark:!stroke-[#9e68ba]"
                  >
                    <path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2" />
                    <path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7" />
                    <path d="M7 3v4a1 1 0 0 0 1 1h7" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="dark:!stroke-[#9e68ba]"
                  >
                    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            )}

            {/* MESSAGE FOR NON-DELETABLE DOMAINS */}
            {!isDelete && (
              <div className="text-xs text-[#9e68ba] dark:!text-[#9e68ba] max-w-xs">
                {t("domainSettings.domain-card.actions.notAllowed")}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
